import { inventoryService, tagService } from "../api/services";

 const assignAuditors = async (
  inventoryId: number | null,
  userId: number,
  setSnackbarMessage: (msg: string) => void,
  setSeverity: (type: "success" | "error") => void,
  setOpenSnackbar: (open: boolean) => void,
  setShowLoader?: (loading: boolean) => void,
  handleMenuClose?: () => void,
  handleCloseSnackbar?: () => void
) => {
  if (!inventoryId) return;

  try {
    setShowLoader?.(true);
    const payload = {
      inventoryId,
      modifiedBy: userId,
    };
    const response = await tagService.assigneAuditor(payload);

    handleMenuClose?.();
    if (response.data.isSuccess) {
      setSeverity("success");
      setSnackbarMessage(response.data.message);
       setTimeout(() => {
        handleCloseSnackbar?.();
      }, 5000);
    } else {
      setSeverity("error");
      setSnackbarMessage("An unexpected error occurred.");
    }
    setOpenSnackbar(true);
  } catch (error) {
    console.error("Failed to assign auditors:", error);
    setSeverity("error");
    setSnackbarMessage("Error assigning auditors.");
    setOpenSnackbar(true);
  } finally {
    setShowLoader?.(false);
  }
};
 const discardInventory = async (
  inventoryId: number | null,
  userId: number,
  setSnackbarMessage: (msg: string) => void,
  setSeverity: (type: "success" | "error") => void,
  setOpenSnackbar: (open: boolean) => void,
  setShowLoader?: (loading: boolean) => void,
  handleMenuClose?: () => void,
  handleCloseSnackbar?: () => void,
  refreshData? : () => void
) => {
  if (!inventoryId) return;

  try {
    setShowLoader?.(true);
    const payload = {
      inventoryId,
      modifiedBy: userId,
    };
    const response = await inventoryService.discardInventory(payload);
    handleMenuClose?.();
    if (response.data.isSuccess) {
      setSeverity("success");
      setSnackbarMessage(response.data.message);
       refreshData?.();
       setTimeout(() => {
        handleCloseSnackbar?.();
      }, 5000);
    } else {
      setSeverity("error");
      setSnackbarMessage("An unexpected error occurred.");
    }
    setOpenSnackbar(true);
  } catch (error) {
    console.error("Failed to assign auditors:", error);
    setSeverity("error");
    setSnackbarMessage("Error assigning auditors.");
    setOpenSnackbar(true);
  } finally {
    setShowLoader?.(false);
  }
};

export const inventoryUtils = {assignAuditors,discardInventory};